import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import CustomTooltip from "../../../../components/common/CustomTooltip/CustomTooltip.jsx";
import { InfoIcon } from "../../../../assets/Svg/SvgImages.jsx";
import { computePerpetualSummary } from '../placeOrder.utils';
import { getPairWalletFromBalance } from '../../../../services/wallet/linkedWallet.utils';
import './PerpetualSummaryCard.scss';
const PerpetualSummaryCard = ({
  side,
  formData,
  leverage,
  priceDecimals,
  quantityDecimals
}) => {
  const selectedPair = useSelector(state => state.ats.selectedPair);
  const activePairBalance = useSelector(state => state.ats.activePairBalance);
  const pairWallet = useMemo(() => getPairWalletFromBalance(activePairBalance), [activePairBalance]);
  const summary = useMemo(() => {
    const fee = side === 0 ? selectedPair?.trade_fee_buy : selectedPair?.trade_fee_sell;
    return computePerpetualSummary({
      selectedSide: side,
      quantity: formData?.quantity,
      price: formData?.price,
      leverage,
      wallet: pairWallet,
      selectedPair,
      tradeFeePercent: fee,
      priceDecimals,
      quantityDecimals
    });
  }, [pairWallet, formData?.price, formData?.quantity, leverage, priceDecimals, quantityDecimals, selectedPair, side]);
  const base = selectedPair?.baseCurrency?.toUpperCase() || '';
  const other = selectedPair?.otherCurrency?.toUpperCase() || '';
  const maxLabel = side === 0 ? 'Max Long' : 'Max Short';
  return <div className="perpetualSummary">
      <div className="perpetualSummary__row">
        <p>Order Value</p>
        <h6>
          {summary.orderValue} {base}
        </h6>
      </div>
      <div className="perpetualSummary__row">
        <p>Cost (Margin)</p>
        <h6>
          {summary.costMargin} {base}
        </h6>
      </div>
      {/* <div className="perpetualSummary__row">
        <p>{maxLabel}</p>
        <h6>
          {summary.maxPosition} {other}
        </h6>
       </div> */}
      <div className="perpetualSummary__row">
        <p className="d-flex align-items-center">
          Est. Liq. Price
          <CustomTooltip placement="right" icon={<InfoIcon />} className="ms-2" toolclass="perpetualLiqTool" text={<p>
                Estimated liquidation price is indicative only and may change with
                market conditions, funding, and margin mode.
              </p>} />
        </p>
        <h6>
          {summary.estimatedLiqPrice != null ? <>
              {summary.estimatedLiqPrice} {base}
            </> : '—'}
        </h6>
      </div>
      <div className="perpetualSummary__row">
        <p>Fees</p>
        <h6>
          {summary.fees} {base}
        </h6>
      </div>
    </div>;
};
export default PerpetualSummaryCard;